import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PLACEHOLDERS } from "@/lib/content";

export function WarmProviderPreview() {
  return (
    <section className="py-12 sm:py-20 overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="mx-auto max-w-2xl text-center">
          <span className="eyebrow text-accent-strong">Meet Our Family</span>
          <h2 className="mt-4 display-md font-display font-medium tracking-[-0.02em] text-foreground">
            {PLACEHOLDERS.PROVIDER_NAME}
          </h2>
          <p className="mt-4 sm:mt-6 text-sm sm:text-base leading-relaxed text-muted-foreground">
            "I started this home because I believe every person deserves to 
            age with dignity, surrounded by love and genuine care. When you 
            walk through our doors, you're not just a visitor—you become 
            part of our extended family."
          </p>
          <p className="mt-3 sm:mt-4 text-sm sm:text-base leading-relaxed text-muted-foreground">
            With five years of experience in senior care, our mission 
            remains simple: to create a place where your loved ones feel 
            truly at home.
          </p>
          <Link
            to="/about"
            className="mt-6 sm:mt-8 inline-flex items-center gap-2 font-medium text-primary hover:text-accent-strong transition-colors"
          >
            Read Our Full Story
            <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}
